import { Component, inject, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { CoverLandingComponent } from "../../UI/cover-landing/cover-landing.component";
import { WhyWorksComponent } from "../../../shared/business/why-works/why-works.component";
import { FreeLevelsComponent } from "../../../shared/business/free-levels/free-levels.component";
import { TeamSectionComponent } from "../../../shared/business/team-section/team-section.component";
import { SubjectSectionComponent } from "../../../shared/business/subject-section/subject-section.component";
import { FavMembersComponent } from "../../../shared/business/fav-members/fav-members.component";
import { LandingService } from "../../../feature/services/landing/landing.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
interface FeatureCard {
  icon: string;
  title: string;
  description: string;
  highlightText?: string;
}
@Component({
  selector: "app-landing",
  standalone: true,
  imports: [
    CoverLandingComponent,
    WhyWorksComponent,
    FreeLevelsComponent,
    TeamSectionComponent,
    SubjectSectionComponent,
    FavMembersComponent,
  ],
  templateUrl: "./landing.component.html",
  styleUrl: "./landing.component.css",
})
export class LandingComponent {
  constructor(private sanitizer: DomSanitizer) {}
  private landingService = inject(LandingService);
  isLoading = signal<boolean>(true);
  landingData = toSignal(this.landingService.getLanding());

  timing = setInterval(() => {
    if (this.landingData()) {
      this.isLoading.set(false);
      clearInterval(this.timing);
      return;
    }
  }, 500);

  features: FeatureCard[] = [
    {
      icon: "tools (1).png",
      title: "Accurate & Curriculum-Aligned Notes",
      description:
        "Our notes are well structured and exam-focused, covering IGCSE, GCSE, CBSE, IB, AP, and all competitive exams. Students get exactly what they need—no fluff, no confusion, just clarity.",
      highlightText: "well structured and exam-focused",
    },
    {
      icon: "paper.png",
      title: "Past Papers With Guided Support",
      description:
        "Access curated past papers with explanations, marking-scheme insights, and topic-wise segmentations to help students understand patterns and improve faster.",
      highlightText: "",
    },
    {
      icon: "exam.png",
      title: "Mastery Starts with the Right Practice",
      description:
        "With thousands of chapter-wise questions, model answers, and exam-level practice sets, Exemplix helps students learn, apply, and master every topic step by step.",
      highlightText: "learn, apply, and master",
    },
    {
      icon: "tools.png",
      title: "Flashcards That Make Revision Easy",
      description:
        "Beautifully crafted digital flashcards break down complex topics into simple, memorable points. Perfect for quick revision and spaced repetition.",
      highlightText: "",
    },
  ];
  formatDescription(description: string, highlightText?: string): SafeHtml {
    if (!highlightText) {
      return this.sanitizer.sanitize(1, description) || description;
    }
    const highlighted = description.replace(
      new RegExp(highlightText, "gi"),
      `<strong class="text-purple-700 font-semibold">${highlightText}</strong>`,
    );
    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
